module.exports = __webpack_public_path__ + "static/img/ent-25.3d323dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-25.jpg
// module id = 4eXf
// module chunks = 51